import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VTooltip from 'v-tooltip'

import './assets/output.css'
import './assets/hljs-nord.css'
import './directives/focus.js';

Vue.config.productionTip = false

Vue.use(VTooltip);
Vue.use(require('vue-shortkey'));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
